import React, { Component } from 'react';
import {Button} from 'reactstrap';
import UploadSuccessPlaceholder from './../../assets/placeholders/upload_success.svg';
import ManualUploadSuccessPlaceholder from './../../assets/placeholders/manual_success.svg';

class UploadSuccess extends Component {
  state = {fromPage : 'CSV_UPLOAD'}
  componentDidMount() {
    // console.log(this.props);
    const {state} = this.props.location;
    if(state) {
      this.setState({
        fromPage : this.props.location.state.fromPage
      })
    }
  }
  render() {
    const {fromPage} = this.state;
    return ( 
      <div className="upload-success-css text-center col-lg-10 col-md-10 col-sm-10">
        <div className="mt60">
        {
          fromPage === 'CSV_UPLOAD' ?
          <img src={UploadSuccessPlaceholder}/> : 
          <img src={ManualUploadSuccessPlaceholder}/>
        }
        </div>
        <div className="mt30">
        {
          fromPage === 'CSV_UPLOAD' ?
          <span>
            Congratulations! You have successfully uploaded data by importing a .csv file.
            You can see your KPIs and find out if benchmarks are available, by creating charts 
            in the Analytics pages.
          </span> :
          <span>
            Congratulations! You have successfully entered your data.
            You can see your KPI scores by creating charts in the Analytics pages.
          </span>
        }
        </div>
        <div className="row mt30" style={{justifyContent:'center'}}>
          <div className="col-md-4">
            <Button 
              className="continueBtn w100 continueBtnTxt" 
              onClick={() => this.props.history.push('/home/analytics/choose-category')}>
              Create a chart
            </Button>
          </div>
          <div className="col-md-4">
            <Button className="goBackBtn w100 goBackBtnTxt" 
              onClick={() => this.props.history.push('/home')}>
              I'll do it later
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
 
export default UploadSuccess;